import i18next from 'i18next';

let i18nInstance: i18next.i18n = null;

export const setI18nInstance = (_i18nInstance: i18next.i18n) => {
  i18nInstance = _i18nInstance;
};

export const createI18nInstance = (locale: string): Promise<i18next.i18n> =>
  new Promise<i18next.i18n>((resolve) => {
    const instance = i18next.createInstance();

    instance
      .use({
        type: 'backend',
        read: (language, namespace, callback) => {
          // We configure how i18next should fetch a translation resource when it
          // needs it: We use Webpack's dynamic imports to fetch resources without
          // increasing our bundle size.
          //
          // See https://webpack.js.org/guides/code-splitting/#dynamic-imports for
          // more information.
          return import(/* webpackChunkName: "[request]" */ `../../locales/messages_${language}.json`)
            .then((translation) => callback(null, translation))
            .catch((error) => callback(error));
        },
      })
      .init(
        {
          // Initial language
          lng: locale,

          // Fallback language
          fallbackLng: 'en',

          // Don't use a key separator (no support for nested translation objects)
          keySeparator: false,
        },
        (err) => {
          if (err) {
            console.log(err);
            instance.changeLanguage('en');
            resolve(instance);
          } else {
            resolve(instance);
          }
        },
      );
  });

export const t = (keys: string | string[], options?: any) => {
  if (!i18nInstance) {
    return keys;
  }

  return i18nInstance.t(keys, options);
};

export const resetI18nInstance = () => {
  i18nInstance = null;
};
